import React, { useState } from 'react'
import { Field } from 'formik'
import { withTranslation } from 'react-i18next';

const PhoneNumber = (props) => {
  const {
    t,
    phone,
    setFieldValue,
    setFieldTouched
  } = props

  const [isEditing, setEditing] = useState(false)

  const togglePhoneEdit = () => {
    setFieldTouched('phone', true, isEditing)
    setEditing(!isEditing)
  }
  const handlePhoneChange = (event) => {
    const val = event.target.value
    const unwantedChars = val.match(/[^-\(\). 0-9]/g) ? val.match(/[^-\(\). 0-9]/g) : []
    const digits = val.match(/[0-9]/g) ? val.match(/[0-9]/g) : []

    if ((unwantedChars.length === 0  && digits.length <= 10) || val.length === 0) {
      setFieldValue('phone', val, false)
    }
  }
  const formatPhone = (num) => {
    let digits = num.replace(/[^0-9]/gi, '')

    for (let i = digits.length; i < 10; i++) {
      digits = digits + "X"
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
  }

  return (
    isEditing
      ? <Field type="phone" className="form-control" name="phone" placeholder={t('placeholdPhone')} value={phone} onChange={handlePhoneChange} onBlur={togglePhoneEdit} />
      : <Field type="phone" className="form-control" name="phone" placeholder={t('placeholdPhone')} value={formatPhone(phone)} onFocus={togglePhoneEdit} />
  )
}

export default withTranslation()(PhoneNumber)